import { formatAmount } from '@cp/src/utils/commonUtils';
import { ColDefsType } from '@navi/web-ui/lib/components/AgTable/types';
import { Typography } from '@navi/web-ui/lib/primitives';
import { ICellRendererParams } from 'ag-grid-community';
import { PAYMENT_STATUS, PAYMENT_MODE } from '../../interfaces/RepaymentHistory.type';
import DateTime from '../DateTime';
import ArrowButtonComponent from './ArrowButtonComponent';
import { GLOBAL } from '@cp/src/constants/Global';

const AGENT_LAPTOP_BORDER_WIDTH = 1400;
const DEFAULT_WIDTH = 200;

const WIDTHS = {
  DATE_WIDTH: '160px',
  AMOUNT_WIDTH: '145px',
  STATUS_WIDTH: '145px',
  MODE_WIDTH: '250px',
  ACTION_WIDTH: '100px'
};

const columnWidth = (percentage: number) => {
  const parent = document.getElementById('repaymentTable') as HTMLElement;
  if (parent && parent?.offsetWidth) {
    return (parent.offsetWidth * percentage) / 100;
  }
  return DEFAULT_WIDTH;
};

const getWidth = (fixedWidth: string, percentage: number) =>
  GLOBAL.SCREEN_WIDTH < AGENT_LAPTOP_BORDER_WIDTH ? fixedWidth : `${columnWidth(percentage)}px`;

const attributesWidth = {
  dateWidth: (percentage: number) => getWidth(WIDTHS.DATE_WIDTH, percentage),
  modeWidth: (percentage: number) => getWidth(WIDTHS.MODE_WIDTH, percentage),
  amountWidth: (percentage: number) => getWidth(WIDTHS.AMOUNT_WIDTH, percentage),
  statusWidth: (percentage: number) => getWidth(WIDTHS.STATUS_WIDTH, percentage),
  actionWidth: (percentage: number) => getWidth(WIDTHS.ACTION_WIDTH, percentage)
};

export const All_CASES_COLUMN_DEFS: ColDefsType[] = [
  {
    field: 'businessDate',
    headerName: 'Transaction date',
    width: attributesWidth.dateWidth(20),
    cellStyle: {
      paddingRight: '0',
      cursor: 'auto'
    },
    cellRenderer: (params: ICellRendererParams) => {
      return <DateTime istDate={new Date(params.data?.orderCompletionTimestamp)} />;
    }
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: attributesWidth.amountWidth(18),
    autoHeight: true,
    cellStyle: {
      paddingRight: '0',
      cursor: 'auto',
      wordBreak: 'break-word'
    },
    cellRenderer: (params: ICellRendererParams) => formatAmount(params.value)
  },
  {
    field: 'status',
    headerName: 'Status',
    width: attributesWidth.statusWidth(18),
    cellStyle: {
      paddingRight: '0',
      cursor: 'auto'
    },
    cellRenderer: (params: ICellRendererParams) => {
      if (params?.value === PAYMENT_STATUS.FAILED) {
        return (
          <Typography color="var(--red-base)" variant="p3">
            Failed
          </Typography>
        );
      }
      if (params?.value === PAYMENT_STATUS.FAILURE) {
        return (
          <Typography color="var(--red-base)" variant="p3">
            Failure
          </Typography>
        );
      }
      if (params?.value === PAYMENT_STATUS.SUCCESS) {
        return (
          <Typography color="var(--green-base)" variant="p3">
            Success
          </Typography>
        );
      }
      if (params?.value === PAYMENT_STATUS.SCHEDULED) {
        return (
          <Typography color="var(--green-base)" variant="p3">
            Success
          </Typography>
        );
      }
      if (params?.value === PAYMENT_STATUS.UNKNOWN) {
        return (
          <Typography color="var(--greyscale-4)" variant="p3">
            Unknown
          </Typography>
        );
      }
      if (params?.value === PAYMENT_STATUS.INITIATED) {
        return (
          <Typography color="var(--yellow-base)" variant="p3">
            Initiated
          </Typography>
        );
      }
      return (
        <Typography color="var(--greyscale-4)" variant="p3">
          {params?.value}
        </Typography>
      );
    }
  },
  {
    field: 'repaymentMode',
    headerName: 'Mode',
    width: attributesWidth.modeWidth(32),
    cellStyle: {
      paddingRight: '0',
      cursor: 'auto'
    },
    cellRenderer: (params: ICellRendererParams) => (
      <div className="flex flex-col">
        <Typography variant="p3">
          {PAYMENT_MODE[params.value as keyof typeof PAYMENT_MODE]}
        </Typography>
        <Typography variant="p5" color="var(--navi-color-gray-c3)">
          {params.data?.repaymentMetadata?.bankName}
        </Typography>
      </div>
    )
  },
  {
    field: 'action',
    headerName: '',
    width: attributesWidth.actionWidth(12),
    cellStyle: {
      paddingRight: '0',
      cursor: 'auto'
    },
    cellRendererSelector: (params: ICellRendererParams) => {
      return {
        component: ArrowButtonComponent,
        params: {
          direction: params.data.toggleState
        }
      };
    }
  }
];
